import {
  DiiaLight as defaultTheme,
} from '#web-components/styles';
import {
  createMuiTheme,
} from '#web-components/exports/theme';
import { ThemeFlags } from '#web-components/types/theme';

export default () => {
  const theme = (APPLICATION_THEME as typeof defaultTheme) || defaultTheme;

  return createMuiTheme({
    spacing: theme.spacing || 6,
    typography: theme.typography,
    breakpoints: {
      values: {
        xs: 0,
        sm: 480, // Phone
        md: 992, // Tablet
        lg: 1548, // Laptop
        xl: 1842, // Desktop
      },
    },
    palette: {
      background: {
        default: theme.colors.layout.backgroundPrimary,
      },
      primary: {
        main: theme.colors.text.primary,
      },
      text: {
        primary: theme.colors.text.primary,
      },
    },
    colors: theme.colors,
    flags: theme.flags as ThemeFlags,
    borders: theme.borders,
    shadow: theme.shadows,
    overrides: {
      MuiCssBaseline: {
        '@global': {
          '@font-face': [...theme.fonts.map((font) => ({
            fontFamily: font.fontFamily,
            fontStyle: font.fontStyle,
            fontWeight: font.fontWeight,
            src: `url('${FTL_PARAMS.resourcesPath}/fonts/${font.fontName}') format('${font.fontFormat}')`,
          }))],
        },
      },
      MuiPaper: {
        elevation4: {
          boxShadow: 'none',
        },
      },
    },
  });
};
